export default __webpack_public_path__ + "static/media/uw-course-search.d8994c00.jpg";